import { jsonldType } from './JsonldStore';

export const updateJsonldType = (value) => jsonldType.update((oldValue) => value);
